import styled from "styled-components";
import theme from "../theme";

export const InteriorRenewalPageContainer = styled.div`
  & .buttons {
    margin-bottom: 5%;
    position: sticky;
    bottom: 5%;
    z-index: 9999;
    & .bottom-buttons {
      & button {
        display: block;
        margin: 0 auto;
      }
      & .bottom-button_sign-up {
        padding: 20px 50px;
        font-size: 20px;
        background-color: ${theme.colors.main_white};
        border-radius: 100px;
        white-space: nowrap;
        text-overflow: ellipsis;
        box-shadow: 4px 4px 10px ${theme.colors.opacityBlack2};
      }
    }
    & .right-bottom-buttons {
      position: absolute;
      right: 15px;
      bottom: 5%;
      display: flex;
      flex-direction: column;
      gap: 10px;
      & .right-bottom-button {
        width: 48px;
        height: 48px;
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 50px;
        transition: all 0.3s;
        display: grid;
        place-content: center;
        &:hover {
          background-color: rgba(0, 0, 0, 1);
        }
        & img, & svg {
          max-height: 30px;
          font-size: 30px;
          color: ${theme.colors.main_white};
        }
      }
    }
  }
  @media ${theme.screens.xs} {
    & .buttons .bottom-buttons .bottom-button_sign-up {
      padding: 18px 40px;
      font-size: 15px;
    }
  }
`;

export const InteriorRenewalHeroSectionContainer = styled.div`
  margin: 0 auto;
  padding: 120px 40px 0px;
  max-width: 1200px;
  & .hero-section-text-box {
    text-align: center;
    & .hero-section_logo {
      height: 30px;
      margin: 0 auto 30px;
    }
    & h1 {
      font-size: 30px;
      font-weight: 500;
    }
    & h2 {
      padding-block: 15px;
      color: ${theme.colors.black_dark_grey};
    }
    & .hero-section-brand-logos {
      width: 90%;
      max-width: 1200px;
      margin: 0 auto;
      padding: 35px 0 100px;
      & ul {
        display: flex;
        justify-content: center;
        & li {
          padding-block: 25px;
          border-block: 1px solid ${theme.colors.black_dark_grey};
          & img {
            object-fit: contain;
          }
        }
      }
    }
    & .hero-section_images {
      & ul {
        display: flex;
        justify-content: space-around;
        gap: 20px;
      }
    }
  }
  @media ${theme.screens.sm} {
    padding: 120px 10px 100px;
  }
  @media ${theme.screens.xs} {
    padding: 120px 0px 50px;
    & .hero-section-text-box {
      & h1 {
        font-size: 21px;
      }
      & h2 {
        & span {
          display: block;
          line-height: 25px;
        }
      }
      & .hero-section-brand-logos{
        padding: 35px 0 50px;
        & ul {
          flex-wrap: wrap;
          border-block: 1px solid ${theme.colors.black_dark_grey};
          & li {
            width: 33%;
            border-block: none;
          }
        }
      }
      & .hero-section_images ul {
        justify-content: space-between;
        gap: 10px;
      }
    }
  }
`;

export const InteriorRenewalIntroduceContainer = styled.div`
  position: relative;
  margin-bottom: 150px;
  & .introduce-background {
    object-fit: contain;
  }
  & .introduce-content {
    max-width: 1200px;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    & .introduce-text-box {
      text-align: center;
      & h2 {
        font-size: 35px;
        font-weight: 600;
      }
      & p {
        padding-block: 25px;
        line-height: 20px;
      }
    }
    & .introduce-arrow-box {
      & .introduce-arrow_circle {
        margin: 0 auto;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: ${theme.colors.main_black};
        position: relative;
        &:after {
          content: "";
          width: 1px;
          height: 50px;
          background-color: ${theme.colors.main_black};
          position: absolute;
          top: 20px;
          left: 50%;
        }
      }
      & .introduce-arrow_second-line {
        margin-top: 50px;
        width: 50%;
        height: 1px;
        position: relative;
        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          right: -1px;
          width: calc(60% + 76px);
          height: 1px;
          background-color: ${theme.colors.main_black};
        }
        &.active1:after,
        &.active2:after {
          width: calc(20% + 26px);
        }
        &.active2,
        &.active3 {
          margin-left: 50%;
          &:after {
            left: 0px;
          }
        }
      }
    }
    & .introduce-button-box {
      & ul {
        margin: 0 auto;
        display: flex;
        justify-content: center;
        gap: 50px;
        & li {
          margin-top: 100px;
          width: 20%;
          height: 100px;
          background-color: ${theme.colors.light_grey};
          font-size: 15px;
          font-weight: 500;
          border-radius: 20px;
          text-align: center;
          display: grid;
          place-items: center;
          line-height: 20px;
          position: relative;
          transition: 0.3s;
          &.active {
            background-color: ${theme.colors.main_black};
            color: ${theme.colors.main_white};
          }
          &.active:after {
            content: "";
            width: 1px;
            height: 100px;
            background-color: ${theme.colors.main_black};
            position: absolute;
            top: -100px;
            left: 50%;
          }
        }
      }
    }
  }
  @media ${theme.screens.sm} {
    & .introduce-content {
      padding-bottom: 70px;
      & .introduce-button-box ul {
          padding-inline: 20px;
        & li {
          margin-top: 50px;
          & p {
            font-size: 13px;
          }
          &.active {
          }
          &.active:after{
            height: 50px;
            top: -50px;
          }
        }
      }
    }
    & .introduce-content .introduce-arrow-box .introduce-arrow_second-line:after {
      width: calc(60% + 63px);
    }
    & .introduce-content .introduce-arrow-box .introduce-arrow_second-line.active1:after,
    & .introduce-content .introduce-arrow-box .introduce-arrow_second-line.active2:after {
      width: calc(20% + 21px);
    }
  }
  @media ${theme.screens.xs} {
    height: 700px;
    & .introduce-background {
      position: absolute;
      bottom: 0;
    }
    & .introduce-content {
      position: relative;
      & .introduce-text-box h2 {
        font-size: 21px;
      }
      & .introduce-arrow-box {
        display: none;
      }
      & .introduce-button-box ul {
        flex-direction: column;
        gap: 10px;
        & li {
          width: 70%;
          height: 70px;
          margin: 0 auto;
          background-color: ${theme.colors.main_black};
          color: ${theme.colors.main_white};
          &.active:after {
            display: none;
          }
        }
      }
    }
  }
`;

export const InteriorRenewalBrandContainer = styled.div`
  margin-bottom: 150px;
  & .brand-text-box {
    text-align: center;
    & h3 {
      font-size: 16px;
      margin-bottom: 10px;
    }
    & h2 {
      font-size: 20px;
      font-weight: 500;
    }
  }
  & .brand-catalog-button {
    padding: 10px;
    border: 0.5px solid ${theme.colors.main_black};
    display: block;
    margin: 50px auto;
    border-radius: 10px;
  }
  & .brand-card-box {
    max-width: 1200px;
    margin: 0 auto;
    & .swiper-slide {
      margin-block: 20px;
      margin-inline: 2px;
      padding: 15px;
      filter: drop-shadow(4px 4px 5px ${theme.colors.opacityBlack2});
      background-color: ${theme.colors.main_white};
      border-radius: 10px;
      & .brand-card-image {
        border-radius: 10px;
      }
      & .brand-card-logo {
        margin: 0 auto;
        padding-block: 10px;
        height: 50px;
      }
      & .brand-card-slogan {
        text-align: center;
        font-size: 14px;
      }
    }
  }
  @media ${theme.screens.xs} {
    & .brand-text-box h2 {
      font-size: 21px;
      & span {
        display: block;
        line-height: 30px;
      }
    }
  }
`;

export const InteriorRenewalFunctionContainer = styled.div`
  margin-bottom: 50px;
  & .function-text-box {
    text-align: center;
    & h3 {
      font-size: 16px;
      margin-bottom: 10px;
    }
    & h2 {
      font-size: 20px;
      font-weight: 500;
      & span {
        font-weight: 600;
        font-size: 25px;
      }
    }
  }
  & .function-effect-box {
    position: relative;
    & .swiper {
      margin-top: 50px;
      width: 50%;
      box-shadow: 4px 4px 20px ${theme.colors.opacityBlack2};
      border-radius: 20px;
      & .swiper-wrapper {
        & .swiper-slide {
          & img {
            width: 100%;
            aspect-ratio: 1/0.69;
            max-width: 1200px;
            margin: 0 auto;
          }
        }
      }
    }
    & .swiper-button-prev:after,
    & .swiper-button-next:after {
      color: black;
      font-size: 30px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
      pointer-events: auto;
    }
    & .swiper-button-prev {
      left: 18%;
    }
    & .swiper-button-next {
      right: 18%;
    }
  }
  & .mobile-function-text-box {
    display: none;
    text-align: initial;
    padding-block: 30px;
    margin-top: 50px;
    margin-bottom: 10px;
    background-color: ${theme.colors.light_grey};
    & p {
      margin: 0 auto 10px;
      width: 80%;
      display: flex;
      gap: 5px;
      align-items: center;
      font-size: 21px;
      font-weight: 300;
      & svg {
        font-size: 25px;
      }
    }

  }
  & .function-end-text {
    text-align: center;
    padding-top: 100px;
    font-size: 20px;
    font-weight: 500;
  }
  @media ${theme.screens.sm} {
    & .function-effect-box .swiper {
      width: 80%;
    }
    & .function-effect-box .swiper-button-prev {
      left: 3%;
    }
    & .function-effect-box .swiper-button-next {
      right: 3%;
    }
  }
  @media ${theme.screens.xs} {
    & .function-effect-box {
      display: none;
    }
    & .mobile-function-text-box {
      display: block;
    }
  }
`;